import React, { useState } from "react";
import styled from "styled-components";
import MoleculeBackgroundSimpleWide from "./CreateEducationContentPage/components/molecules/MoleculeBackgroundSimpleWide";

const TestMoleculeBackgroundSimpleWide = () => {
  const [selectedConcept, setSelectedConcept] = useState("concept1");
  const [testTitle, setTestTitle] = useState([
    "2025년 교내 논술대회",
    "참가 안내"
  ]);
  const [testContent, setTestContent] = useState([
    `**일시**
2025년 5월 23일(금)
15:20 ~ 16:10 (50분)

**신청 기한**  
2025년 5월 14일(수) ~ 16일(금)
12:00 까지

**신청 방법**
구글 신청서 제출 (경원중 계정으로 로그인)
http://bit.ly/example`,
    `**대회 장소**
1학년 : 3학년 1반 교실
2학년 : 3학년 2반 교실  
3학년 : 3학년 3반 교실

**논술 주제**
당일 현장 공개
필기도구(연필, 샤프, 지우개 등) 준비 필요

**수상 인원**
학년별 시상, 학년별 참가 인원의 20% 이내`
  ]);

  const concepts = [
    { value: "concept1", name: "Peach Bloom" },
    { value: "concept2", name: "Lavender Cream" },
    { value: "concept3", name: "Mint Breeze" },
    { value: "concept4", name: "Yellow Moment" },
    { value: "concept5", name: "Classic Bronze" },
    { value: "concept6", name: "Retro Blue" },
    { value: "concept7", name: "Modern Edge" },
    { value: "concept8", name: "Tech Black" },
    { value: "concept9", name: "Fresh Navy" }
  ];

  return (
    <TestContainer>
      <ControlPanel>
        <h2>MoleculeBackgroundSimpleWide 테스트</h2>
        
        <ControlGroup>
          <label>디자인 컨셉:</label>
          <select 
            value={selectedConcept} 
            onChange={(e) => setSelectedConcept(e.target.value)}
          >
            {concepts.map(concept => (
              <option key={concept.value} value={concept.value}>
                {concept.name}
              </option>
            ))}
          </select>
        </ControlGroup>

        <ControlGroup>
          <label>제목 1:</label>
          <input 
            type="text" 
            value={testTitle[0]} 
            onChange={(e) => setTestTitle([e.target.value, testTitle[1]])}
          />
        </ControlGroup>

        <ControlGroup>
          <label>제목 2:</label>
          <input 
            type="text" 
            value={testTitle[1]} 
            onChange={(e) => setTestTitle([testTitle[0], e.target.value])}
          />
        </ControlGroup>

        <ControlGroup>
          <label>내용 1 (왼쪽 컬럼):</label>
          <textarea 
            rows="6"
            value={testContent[0]} 
            onChange={(e) => setTestContent([e.target.value, testContent[1]])}
          />
        </ControlGroup>

        <ControlGroup>
          <label>내용 2 (오른쪽 컬럼):</label>
          <textarea 
            rows="6"
            value={testContent[1]} 
            onChange={(e) => setTestContent([testContent[0], e.target.value])}
          />
        </ControlGroup>

        <ScaleInfo>
          <p><strong>실제 크기:</strong> 3840 x 2160 픽셀</p>
          <p><strong>현재 표시:</strong> 50% 스케일</p>
          <p>스크롤하여 전체 컴포넌트를 확인하세요</p>
        </ScaleInfo>
      </ControlPanel>

      <PreviewContainer>
        <PreviewWrapper>
          <MoleculeBackgroundSimpleWide
            contentsDesignConcept={selectedConcept}
            title={testTitle}
            content={testContent}
          />
        </PreviewWrapper>
      </PreviewContainer>
    </TestContainer>
  );
};

export default TestMoleculeBackgroundSimpleWide;

const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const ControlPanel = styled.div`
  background: white;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  max-height: 300px;
  overflow-y: auto;
`;

const ControlGroup = styled.div`
  margin-bottom: 15px;
  
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 600;
    color: #333;
  }
  
  input, select, textarea {
    width: 100%;
    max-width: 400px;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
  }
  
  textarea {
    resize: vertical;
    font-family: 'Pretendard', monospace;
  }
`;

const ScaleInfo = styled.div`
  background: #e3f2fd;
  padding: 12px;
  border-radius: 6px;
  margin-top: 20px;
  border-left: 4px solid #2196f3;
  
  p {
    margin: 4px 0;
    font-size: 14px;
    color: #1565c0;
  }
`;

const PreviewContainer = styled.div`
  flex: 1;
  padding: 20px;
  overflow: auto;
  background: #e0e0e0;
`;

const PreviewWrapper = styled.div`
  transform: scale(0.5);
  transform-origin: top left;
  width: 3840px;
  height: 2160px;
  border: 2px solid #666;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  background: white;
`; 